"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentType = documentType;
exports.validDocument = validDocument;
exports.maskCombinedByLength = maskCombinedByLength;
exports.maskDocument = maskDocument;
const normalize_1 = require("./normalize");
const cnpj_1 = require("./cnpj");
const cpf_1 = require("./cpf");
const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;
function documentType(value) {
    const len = (0, normalize_1.onlyAlnum)(value).length;
    if (len === CPF_LENGTH)
        return 'cpf';
    if (len === CNPJ_LENGTH)
        return 'cnpj';
    return null;
}
function validDocument(value) {
    const type = documentType(value);
    if (type === 'cpf')
        return (0, cpf_1.validCpf)(value);
    if (type === 'cnpj')
        return (0, cnpj_1.validCnpj)(value);
    return false;
}
function maskCombinedByLength(value) {
    const alnum = (0, normalize_1.onlyAlnum)(value);
    // A CPF is digits-only, so any letter unambiguously means CNPJ. Detect it early so a
    // combined CPF/CNPJ input field switches to the alphanumeric mask before the 12th
    // character — otherwise the digits-only CPF mask would block letters in positions 3-12.
    if (/[A-Z]/.test(alnum))
        return 'cnpj';
    return alnum.length > CPF_LENGTH ? 'cnpj' : 'cpf';
}
function maskDocument(value) {
    return maskCombinedByLength(value) === 'cnpj' ? (0, cnpj_1.maskCnpj)(value) : (0, cpf_1.maskCpf)(value);
}
